import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../components/partials/Breadcrumb";
import { BiCategory } from "react-icons/bi";
import { Formik } from "formik";
import { Alerts, GetSettings } from "../../../../helpers";

const breadcrumbs = [
    {
        id: 1,
        label: "Dashboard",
        link: "/",
    },
    {
        id: 2,
        label: "SEO",
        link: "/app/product/categories",
    },
    {
        id: 3,
        label: "Update",
        link: "/",
    },
];

const SeoUpdate = () => {
  const [pageId, setPageId] = useState(1);
  const [seoDetails, setSeoDetails] = useState(null);
  const [seoPages, setSeoPages] = useState([]);

  const getSeoPages = async ()=>{
       const resp = await GetSettings.getSeoPages();
       console.log(resp);
    if(resp && resp.status){
        setSeoPages(resp.seo_detailList);
    }
  }

  const getSeoDetails = async (id)=>{
    const resp = await GetSettings.getSeoDetails(id);
    if(resp && resp.status){
        setSeoDetails(resp.seo_details);
    }else{
        setSeoDetails(null);
    }
  }

  useEffect(()=>{
     getSeoDetails(pageId);
     getSeoPages();
  },[pageId])

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
       
        const resp = await GetSettings.updateSeoDetails(pageId, values);
        if(resp && resp.status){
            Alerts.alertMessage(resp.message, 'top-right', 'success');
        }else{
             Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
        setSubmitting(false);
    };

    return (
        <>
       
            <div className="innerPageWrapper">
                <div className="container-fluid">
                    <div className="page-title">
                        <h2>
                            <BiCategory /> Search Engine Optimization
                        </h2>

                    </div>
                    <div class="mb-3">
                        <label for="page_name" class="form-label">Page Name</label>
                        <select className="form-control" onChange={(e)=>setPageId(e.target.value)}>
                            {
                                seoPages.length > 0 && seoPages.map((page, i)=>{
                                    return  <option value={page.page_id} key={i}>{page.page_name}</option>
                                })
                            }
                           
                          
                        </select>
                    </div>
                    {
                        seoDetails !== null &&  <Formik
                        enableReinitialize
                        initialValues={{
                            meta_title: seoDetails.meta_title,
                            meta_description:seoDetails.meta_description,
                            meta_keywords:seoDetails.meta_keywords,
                            canonical_url:seoDetails.canonical_url,
                            robots:seoDetails.robots,
                            og_title: seoDetails.og_title,
                            og_description:seoDetails.og_description,
                            og_image:seoDetails.og_image,
                            twitter_title: seoDetails.twitter_title,
                            twitter_description: seoDetails.twitter_description,
                            twitter_image:seoDetails.twitter_image
                        }}
                        onSubmit={handleSubmit}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <div className="card" style={{ marginTop: 20 }}>

                                    <div className="card-body">
                                        <div class="mb-3">
                                            <label for="metaTitle" class="form-label">Meta Title</label>
                                            <input type="text" class="form-control" id="metaTitle" name="meta_title" placeholder="Enter meta title"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.meta_title}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <label for="metaDescription" class="form-label">Meta Description</label>
                                            <textarea class="form-control" id="metaDescription" name="meta_description" rows="3" placeholder="Enter meta description" onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.meta_description}></textarea>
                                        </div>
                                        <div class="mb-3">
                                            <label for="metaKeywords" class="form-label">Meta Keywords</label>
                                            <input type="text" class="form-control" id="metaKeywords" name="meta_keywords" placeholder="e.g. electronics, gadgets, accessories" onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.meta_keywords} />
                                        </div>
                                        <div class="mb-3">
                                            <label for="canonicalUrl" class="form-label">Canonical URL</label>
                                            <input type="text" class="form-control" id="canonicalUrl" name="canonical_url" placeholder="https://example.com/category" onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.canonical_url} />
                                        </div>
                                        <div class="mb-3">
                                            <label for="robots" class="form-label">Robots</label>
                                            <input type="text" class="form-control" id="robots" name="robots" placeholder="index, follow" onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.robots} />
                                        </div>
                                        <hr />
                                        <h5 style={{ marginBottom: 10 }}>Open Graph (Facebook)</h5>
                                        <div class="mb-3">
                                            <label for="ogTitle" class="form-label">OG Title</label>
                                            <input type="text" class="form-control" id="ogTitle" name="og_title" placeholder="Enter OG title" onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.og_title} />
                                        </div>
                                        <div class="mb-3">
                                            <label for="ogDescription" class="form-label">OG Description</label>
                                            <textarea class="form-control" id="ogDescription" name="og_description" rows="3" placeholder="Enter OG description"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.og_description}
                                            ></textarea>
                                        </div>
                                        <div class="mb-3">
                                            <label for="ogImage" class="form-label">OG Image URL</label>
                                            <input type="text" class="form-control" id="ogImage" name="og_image" placeholder="https://example.com/image.jpg"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.og_image}
                                            />
                                        </div>
                                        <hr />
                                        <h5 style={{ marginBottom: 10 }}>Twitter Card</h5>
                                        <div class="mb-3">
                                            <label for="twitterTitle" class="form-label">Twitter Title</label>
                                            <input type="text" class="form-control" id="twitterTitle" name="twitter_title" placeholder="Enter Twitter title"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.twitter_title}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <label for="twitterDescription" class="form-label">Twitter Description</label>
                                            <textarea class="form-control" id="twitterDescription" name="twitter_description" rows="3" placeholder="Enter Twitter description" onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.twitter_description}></textarea>
                                        </div>
                                        <div class="mb-3">
                                            <label for="twitterImage" class="form-label">Twitter Image URL</label>
                                            <input type="text" class="form-control" id="twitterImage" name="twitter_image" placeholder="https://example.com/twitter-image.jpg" onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.twitter_image} />
                                        </div>
                                        <button
                                                                type="submit"
                                                                className="btn btn-primary "
                                                                disabled={isSubmitting}
                                                            >
                                                                {isSubmitting ? "Please wait..." : "Save"}
                                                            </button>
                                    </div>
                                </div>

                            </form>
                        )
                        }
                    </Formik>
                    }
                   
                </div>
            </div>
        </>
    );
};

export default SeoUpdate;
